import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ahkhhvtpz: FaireBrandEntity = {
  token: "b_4ahkhhvtpz",
  type: "brand",
  name: "Collections by Fame Accessories",
  avatarUrl:
    "https://cdn.faire.com/fastly/1687535b604f9b7a6f23dcd2ed133392fa16d89a260b05d4e3058ee1399f6b17.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a560740052f83e423b95c6f393ef7d5661b169e514d1eeb7ac41dd076bc91422.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1687535b604f9b7a6f23dcd2ed133392fa16d89a260b05d4e3058ee1399f6b17.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a560740052f83e423b95c6f393ef7d5661b169e514d1eeb7ac41dd076bc91422.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.8,
  reviewCount: 496,
  isTopShop: true,
  isInsider: true,
  description:
    "At Fame Accessories, we help retailers thrive by delivering trend-driven fashion accessories that sell—fast.\n\nSince 2010, our mission has been to make it easy for boutiques and retailers around the world to offer the latest styles at accessible price points. From everyday essentials to statement-makers, our collections are curated with your customers in mind—balancing quality, value, and on-trend design.\n\nBased in Los Angeles and inspired by global fashion hubs, we stay ahead of the curve so you don’t have to. With fast turnaround times, consistent bestsellers, and a wide product assortment, we make sourcing simple and seamless.\n\nWhether you're a small boutique or a major retailer, Fame is your trusted partner for accessories that move.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:07.434Z",
    importedBy: "entity-db-cli",
  },
};
